var Freedom_UproxyLogging;
(function (Freedom_UproxyLogging) {
    var LogManager = (function () {
        function LogManager(module_, dispatchEvent_) {
            this.module_ = module_;
            this.dispatchEvent_ = dispatchEvent_;
            this.getEncrypedLogBuffer = function (tags, continuation) {
                continuation(Logging.getEncrypedLogBuffer(tags));
            };
            this.getLogs = function (tags, continuation) {
                continuation(Logging.getLogs(tags));
            };
            this.clearLogs = function (continuation) {
                Logging.clearLogs();
                continuation();
            };
            this.enable = function (continuation) {
                Logging.enable();
                continuation();
            };
            this.disable = function (continuation) {
                Logging.disable();
                continuation();
                ;
            };
            this.setConsoleFilter = function (args, continuation) {
                Logging.setConsoleFilter(args);
                continuation();
            };
        }
        return LogManager;
    })();
    Freedom_UproxyLogging.LogManager = LogManager;
    var Log = (function () {
        function Log(module_, dispatchEvent_, tag_) {
            var _this = this;
            this.module_ = module_;
            this.dispatchEvent_ = dispatchEvent_;
            this.tag_ = tag_;
            this.debug = function (msg, args, continuation) {
                _this.logger_.debug(msg, args);
                continuation();
            };
            this.info = function (msg, args, continuation) {
                _this.logger_.info(msg, args);
                continuation();
            };
            this.warn = function (msg, args, continuation) {
                _this.logger_.warn(msg, args);
                continuation();
            };
            this.error = function (msg, args, continuation) {
                _this.logger_.error(msg, args);
                continuation();
            };
            this.logger_ = new Logging.Log(tag_);
        }
        return Log;
    })();
    Freedom_UproxyLogging.Log = Log;
})(Freedom_UproxyLogging || (Freedom_UproxyLogging = {}));
//# sourceMappingURL=uproxylogging.js.map